import React, { useEffect, useRef, useState } from 'react';
import api from '../services/api';
import { fmtMoney } from '../utils/moeda';

export default function SugestoesEf({ faturaId, onAssociada, alterada = false }) {
    const [dados, setDados] = useState(null), [erro, setErro] = useState('');
    const [ocupado, setOcupado] = useState(false), [tentativa, setTentativa] = useState(0);
    const emCurso = useRef(false);
    useEffect(() => {
        let cancelar = false, timer;
        setDados(null); setErro('');
        const carregar = async () => {
            try {
                const r = await api.get('/gestao-financeira/faturas-reais/' + faturaId + '/sugestoes-ef');
                if (cancelar) return;
                setDados(r.data);
                if (r.data.leitura?.estado === 'pendente') timer = setTimeout(carregar, 5000);
            } catch (e) { if (!cancelar) setErro(e.response?.data?.error || 'Não foi possível consultar as sugestões.'); }
        };
        carregar();
        return () => { cancelar = true; clearTimeout(timer); };
    }, [faturaId, tentativa]);
    const associar = async c => {
        if (emCurso.current || alterada) return;
        emCurso.current = true; setOcupado(true); setErro('');
        try {
            await api.post('/gestao-financeira/faturas-reais/' + faturaId + '/associar-sugestao', { chave: c.chave });
            await onAssociada();
        } catch (e) { setErro(e.response?.data?.error || 'A associação não foi efetuada.'); }
        finally { emCurso.current = false; setOcupado(false); }
    };
    const titulo = { referencia: 'Referência identificada no documento', provavel: 'Sugestão provável', confirmar: 'Por confirmar', pendente: 'A ler documento', sem_sugestao: 'Sem sugestão segura' };
    if (dados && ['associada', 'dispensada'].includes(dados.estado)) return null;
    return <section className="gf-sugestoes-ef" aria-label="Sugestões de encomenda fornecedor" aria-busy={ocupado}>
        <strong>{titulo[dados?.estado] || 'A consultar sugestões…'}</strong>
        {dados?.motivo && <p>{dados.motivo}</p>}
        {dados?.leitura?.aviso && <p className="gf-sugestao-aviso">{dados.leitura.aviso}</p>}
        {alterada && <p className="gf-sugestao-aviso">Guarde as alterações da fatura antes de usar uma sugestão.</p>}
        {erro && <p role="alert" className="gf-sugestao-aviso">{erro} <button type="button" disabled={ocupado} onClick={() => setTentativa(v => v + 1)}>Voltar a consultar</button></p>}
        {dados?.candidatos?.map(c => <article key={c.chave} className="gf-sugestao-card">
            <strong>{c.numero}</strong><p>{c.fornecedor}</p><p>{c.motivo}</p>
            {c.trecho && <details><summary>Texto encontrado no documento</summary><blockquote>{c.trecho}</blockquote></details>}
            <p>Total sem IVA: {fmtMoney(c.valor_total)} · Disponível: {fmtMoney(c.saldo)}</p>
            <details><summary>{c.linhas.length} {c.linhas.length === 1 ? 'linha da encomenda' : 'linhas da encomenda'}</summary>
                <ul>{c.linhas.map(l => <li key={l.id}>{l.descricao || 'Sem descrição'} — {fmtMoney(l.valor_total)}</li>)}</ul>
            </details>
            {!!c.avisos.length && <ul className="gf-sugestao-aviso">{c.avisos.map(a => <li key={a}>{a}</li>)}</ul>}
            <button type="button" disabled={ocupado || alterada || !c.pode_associar} onClick={() => associar(c)}>{ocupado ? 'A associar…' : 'Associar esta EF'}</button>
        </article>)}
    </section>;
}
